<template>
  <div> 
    <Navbar />
    <div class="row vh-100">
      <div class="col-md-12">
        <iframe
            :src="'data:application/pdf;base64,' + docIframe"
            width="100%"
            height="100%"
          ></iframe>
      </div>
    </div>

    <Loading />
  </div>
</template>
<script>
import Loading from "./../../componentes/ImgLoading/loading.vue";
import Navbar from "./tools/Navbar.vue";

export default {
  components: {
    Loading,
    Navbar,
  },
  data: function() {
    return {
      docIframe: "",
      render: false,
    };
  },
  methods: {
    async getDocumentPdf(
      poliza,
      endoso,
      cotizacion,
      recibo,
      documento,
      cotizador
    ) {
      const payload = {
        metodo: "OBTIENEPDFDOCS",
        data: {
          POLIZA: poliza,
          ENDOSO: endoso,
          COTIZACION: cotizacion,
          RECIBO: recibo,
          TIPOCOTIZADOR: cotizador,
          TIPODOCUMENTO: documento,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then((_) => {
        const response = this.$store.getters.getRespuestaREST;
        this.docIframe = encodeURI(response.data);
        this.render = true;
      });
    },
  },
  async mounted() {
    await this.getDocumentPdf(
      this.$route.query.poliza,
      this.$route.query.endoso,
      this.$route.query.cotizacion,
      this.$route.query.recibo,
      this.$route.query.documento,
      this.$route.query.cotizador
    );
  },
};
</script>
<style>
.navbar-custom {
  background-color: #003b71 !important;
}
.font-white {
  color: white !important;
}
</style>
